import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ReportVersionService {
  public showLegacy = false;
}
